import { useEffect, useRef, useState, useContext } from "react";
import { HomeComponent } from "../Components/Homescreen/Home";
import { About } from "../Components/Homescreen/About";
import { Contact } from "../Components/Homescreen/Contact";
import { Footer } from "../Components/Homescreen/Footer";
import SvgDecorator from "../Components/Homescreen/SvgDecor";
import { WhyChooseUsComponent } from "../Components/Homescreen/WhyChooseUs";
import { JoinSegmentCloudComponent } from "../Components/Homescreen/JoinSegment";
import Navbar from "../Components/Homescreen/Navbar";
import PriceEstimationComponent from "../Components/Homescreen/PriceEstimation";
import { LandingLoader } from "../Components/Elements/LandingLoader";
import { appContext } from "../App";
import { CryptoIconsRow } from "../Components/Homescreen/CryptoIconsRow";
import MinerTable from "../Components/Homescreen/MInerData";

export const Home = () => {
    const [isLoaded, setIsLoaded] = useState(false);
    const [navBgColor, setNavBgColor] = useState("bg-transparent");
    const [navIconSize, setNavIconSize] = useState("h-12");
    const { darkMode } = useContext(appContext);

    const aboutRef = useRef<HTMLDivElement | null>(null);
    const whyChooseUsRef = useRef<HTMLDivElement | null>(null);
    const joinSegmentRef = useRef<HTMLDivElement | null>(null);
    const priceEstimationRef = useRef<HTMLDivElement | null>(null);
    const contactRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        // Show loader for at least 1.5 seconds
        const timer = setTimeout(() => {
            setIsLoaded(true);
        }, 1000);

        const handleScroll = () => {
            if (window.scrollY > 20) {
                setNavBgColor("bg-scrolled"); // Handled by dynamic logic in Navbar
                setNavIconSize('h-10');
            } else {
                setNavBgColor("bg-transparent");
                setNavIconSize('h-12');
            }
        };

        window.addEventListener("scroll", handleScroll);
        return () => {
            window.removeEventListener("scroll", handleScroll);
            clearTimeout(timer);
        };
    }, []);

    if (!isLoaded) {
        return <LandingLoader />;
    }

    return (
        <div className={`min-h-screen transition-colors duration-500 ${darkMode ? 'bg-slate-950 text-white' : 'bg-white text-slate-900'}`}>
            <div className="relative overflow-hidden">
                <SvgDecorator />
                <Navbar
                    navBgColor={navBgColor}
                    navIconSize={navIconSize}
                    joinSegmentRef={joinSegmentRef}
                    priceEstimationRef={priceEstimationRef}
                    aboutRef={aboutRef}
                    whyChooseUsRef={whyChooseUsRef}
                    contactRef={contactRef}
                />

                <main className="relative">
                    <HomeComponent contactRef={contactRef} />
                    <CryptoIconsRow/>
                    <PriceEstimationComponent ref={priceEstimationRef} />
                    <MinerTable/>
                    <About ref={aboutRef} />
                    <JoinSegmentCloudComponent ref={joinSegmentRef} />
                    <WhyChooseUsComponent ref={whyChooseUsRef} />
                    <Contact ref={contactRef} />
                </main>

                <Footer 
                    whyChooseUsRef={whyChooseUsRef}
                    priceEstimationRef={priceEstimationRef}
                    contactRef={contactRef}
                />
            </div>
        </div>
    );
};
